// extracted by mini-css-extract-plugin
export default {"root":"LocationBadge_root__PbDyB marketplaceTinyFontStyles"};